import styles from './FJMobileTextToImagePreset.module.less';
import mainImg from '../../../assets/base64/mobile-text-to-image-preview';

const FJMobileTextToImagePreset = () => {
    return (
        <div className={styles.inner}>
            <div className={styles.main_img} style={{ backgroundImage: `url(${mainImg})` }}></div>
        </div>
    );
};
export default FJMobileTextToImagePreset;
